import React, { PropsWithChildren } from "react";
import { styled, Typography, TypographyProps } from "@mui/material";

export const H1 = ({
    children,
    ...rest
}: PropsWithChildren<TypographyProps>) => (
    <Typography variant={"h1"} {...rest}>
        {children}
    </Typography>
);

export const H2 = ({
    children,
    ...rest
}: PropsWithChildren<TypographyProps>) => (
    <Typography variant={"h2"} {...rest}>
        {children}
    </Typography>
);
export const H3 = ({
    children,
    ...rest
}: PropsWithChildren<TypographyProps>) => (
    <Typography variant={"h3"} {...rest}>
        {children}
    </Typography>
);
export const H4 = ({
    children,
    ...rest
}: PropsWithChildren<TypographyProps>) => (
    <Typography variant={"h4"} {...rest}>
        {children}
    </Typography>
);
export const H5 = ({
    children,
    ...rest
}: PropsWithChildren<TypographyProps>) => (
    <Typography variant={"h5"} {...rest}>
        {children}
    </Typography>
);
export const H6 = ({
    children,
    ...rest
}: PropsWithChildren<TypographyProps>) => (
    <Typography variant={"h6"} {...rest}>
        {children}
    </Typography>
);
export const P = ({
    children,
    ...rest
}: PropsWithChildren<TypographyProps>) => (
    <Typography variant={"body1"} {...rest}>
        {children}
    </Typography>
);
export const Caption = ({
    children,
    ...rest
}: PropsWithChildren<TypographyProps>) => (
    <Typography variant={"caption"} {...rest}>
        {children}
    </Typography>
);

export const Span = styled(`span`)(({ theme }) => ({
    backgroundColor: "crimson",
}));
